import React from "react";
import { Helmet } from "react-helmet-async";

const YourHelp: React.FC = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-sauna-beige px-4">
    <Helmet>
      <title>Your Help | SaunaDip</title>
      <meta name="description" content="Thank you for your interest in helping SaunaDip!" />
    </Helmet>
    <h1 className="text-3xl font-bold text-sauna-orange mb-4 mt-8 text-center">Thank You for Your Help!</h1>
    <p className="text-lg text-sauna-navy/80 text-center max-w-md mb-8">
      We appreciate your interest in shaping the future of wild sauna and cold plunge experiences. Stay tuned for more ways to get involved!
    </p>
  </div>
);

export default YourHelp; 